import { ReactComponent as BackIcon } from "./backarrow.svg";
import { ReactComponent as UserpludIcon } from "./userplus.svg";
import { ReactComponent as LoginIcon } from "./login.svg";
import { ReactComponent as DownIcon } from "./downarrow.svg";

export const ICON_MAP = {
  back: BackIcon,
  signup: UserpludIcon,
  login: LoginIcon,
  arrowdown: DownIcon
};

export {
  BackIcon,
  UserpludIcon,
  LoginIcon,
  DownIcon
};
